import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";

import FeaturedProjects from "./FeaturedProjects";
import CaseStudy from "./CaseStudy";
import App from "./App";
import Blogs from "./Blogs";
import AdminPage from "./AdminPage";
import AllProjects from "./AllProjects";
import Ticket from "./Ticket";
import CharacterSelection from "./CharacterSelection";
import CardsShowcase from "./CardsShowcase";
import ProjectDetail from "./ProjectDetail";
import AboutMe from "./AboutMe";
import { getStoredPetCard } from "./SitePetProgress";
import ResumePage from "./ResumePage";
import { hasAdminAuthCallback, handleAuthRedirect } from "./supabaseClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

const ADMIN_ROUTE = process.env.REACT_APP_ADMIN_ROUTE || "/admin";
const TICKET_DONE_KEY = "portfolio_ticket_done";

function hasFinishedTicket() {
  return localStorage.getItem(TICKET_DONE_KEY) === "true";
}

function AuthCallbackGate({ children }) {
  const [resolved, setResolved] = useState(!hasAdminAuthCallback());

  useEffect(() => {
    if (!hasAdminAuthCallback()) {
      setResolved(true);
      return undefined;
    }

    let mounted = true;

    const run = async () => {
      await handleAuthRedirect();
      if (mounted) {
        setResolved(true);
      }
    };

    run();

    return () => {
      mounted = false;
    };
  }, []);

  if (!resolved) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        Loading...
      </div>
    );
  }

  return children;
}

function EntryRedirect() {
  const hasPetCard = Boolean(getStoredPetCard());

  if (hasPetCard) {
    return <Navigate to="/featured-projects" replace />;
  }

  if (hasFinishedTicket()) {
    return <Navigate to="/character-selection" replace />;
  }

  return <Navigate to="/ticket" replace />;
}

function TicketRoute() {
  const hasPetCard = Boolean(getStoredPetCard());

  if (hasPetCard) {
    return <Navigate to="/featured-projects" replace />;
  }

  return <Ticket />;
}

function CharacterSelectionRoute() {
  const hasPetCard = Boolean(getStoredPetCard());

  if (hasPetCard) {
    return <Navigate to="/featured-projects" replace />;
  }

  return <CharacterSelection />;
}

root.render(
  <HashRouter>
    <AuthCallbackGate>
      <Routes>
        <Route path="/" element={<EntryRedirect />} />

        <Route path={ADMIN_ROUTE} element={<AdminPage />} />

        <Route path="/featured-projects" element={<FeaturedProjects />} />
        <Route path="/case-study" element={<CaseStudy />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/all-projects" element={<AllProjects filter="all" />} />

        <Route path="/ticket" element={<TicketRoute />} />
        <Route path="/Ticket" element={<Navigate to="/ticket" replace />} />

        <Route
          path="/character-selection"
          element={<CharacterSelectionRoute />}
        />
        <Route
          path="/characterselection"
          element={<Navigate to="/character-selection" replace />}
        />

        <Route path="/cards-showcase" element={<CardsShowcase />} />
        <Route path="/project/:projectId" element={<ProjectDetail />} />
        <Route path="/about-me" element={<AboutMe />} />

        <Route path="/old-home" element={<App />} />
        <Route path="/resume" element={<ResumePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthCallbackGate>
  </HashRouter>
);
